import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Footer from "../elements/footer";
import axios from "axios";
import NavBar from "../elements/navBar";
function DetailedFormation(props) {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [spinner, setSpinner] = useState(false);

  useEffect(() => {
    setSpinner(true);
    const getFormations = async () => {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + `activities/Formation/${id}`
      );
      setData(response.data.formation);
      console.log(data);
      response.data.formation && setSpinner(false);
    };
    getFormations();
  }, []);

  return (
    <div style={{ backgroundColor: "#f3f3f3" }}>
      <Helmet>
        <title>Learn modern Tech</title>
        <meta
          name="description"
          content={data.description && data.description}
        />
        <meta name="keywords" content={data.name && data.name} />
      </Helmet>
      <NavBar />

      {spinner ? (
        <div className="spinner-border" role="status">
          <span className="sr-only"></span>
        </div>
      ) : (
        <div className="detailedFormation">
          <div className="detailTitle">
            <Link
              to="/learn"
              className="return"
              // onClick={retour}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="currentColor"
                className="bi bi-arrow-left backarrow"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                />
              </svg>
              See all workshops
            </Link>
            {/* <div className="formationTitleDetail">{props.formation.name && props.formation.name}</div> */}
            <div className="formationTitleDetail">{data.name && data.name}</div>
          </div>
          <div className="inlineImage">
            <img
              className="imageFormation"
              src={
                // process.env.REACT_APP_BACKEND_URL + `${props.formation.images && props.formation.images[0]}`
                //  props.formation.images && props.formation.images.url
                data.images && data.images.url
              }
              alt=""
            />

            <div className="mobileCenter">
              <div className="workshopBenefits">
                <div className="workshopbenefit">✔ Start from zero</div>
                <div className="workshopbenefit">✔ Learn the concepts</div>
                <div className="workshopbenefit">
                  ✔ Develop projects from scratch
                </div>
                <div className="workshopbenefit">
                  ✔ Earn a certificate and showcase your skills
                </div>
              </div>
              {data.program && (
                <div className="participateButton">
                  <a
                    style={{ color: "white" }}
                    href={data.program}
                    target="_blank"
                    rel="noreferrer"
                    download
                  >
                    Télécharger le Programme en PDF
                  </a>
                </div>
              )}
            </div>
          </div>

          <div className="participatelineObjectifs">
            <div className="formationContent">
              {data.description && (
                <ul>
                  <div className="objectifFormation">Description :</div>
                  {data.description}
                </ul>
              )}
            </div>
            <div className="tabledetail">
              {/* {data.prix && (
                <div className="rowTableDetail">
                  <b>💰 Price : </b> {data.prix}
                </div>
              )} */}
              {data.period && (
                <div className="rowTableDetail">
                  <b>🕒 Duration : </b> {data.period}
                </div>
              )}
              {data.age && (
                <div className="rowTableDetail">
                  <b>💁‍♂ Age : </b> {data.age}
                </div>
              )}
              {data.difficulty && (
                <div className="rowTableDetail">
                  <b>💪🏻 Difficulty : </b> {data.difficulty}
                </div>
              )}
              {data.date && data.date !== " " && (
                <div className="rowTableDetail">
                  <b>📅 Date : </b> {data.date}
                </div>
              )}
            </div>
          </div>
          <div className="participatelineObjectifs">
            <div className="coveredTopics">
              {data.objectifs && (
                <div className="coveredTopicRef">Objectifs :</div>
              )}
              {data.objectifs &&
                data.objectifs.split("/").map((e, i) => (
                  <div key={i} className="topic">
                    ➡ {e}
                  </div>
                ))}
            </div>
            <div className="coveredTopics">
              {data.prerequis && (
                <div className="coveredTopicRef">Prérequis :</div>
              )}
              {data.prerequis &&
                data.prerequis.split("/").map((e, i) => (
                  <div key={i} className="topic">
                    ➡ {e}
                  </div>
                ))}
            </div>
          </div>

          <div>
            <div className="startNow">Commencez dès maintenant !</div>
            <div className="enrollAndPay">
              Inscrivez-vous ensemble, payer moins
            </div>

            {
              (data.prixParGroupeOnline || data.prixParGroupeOnsite) ? <div className="teams">
              <div className="teamOnsite">
                <div className="priceByTeamTitle">Étudier en présentiel</div>
                {data.prixParGroupeOnsite &&
                  data.prixParGroupeOnsite.split("/").map((e) => (
                    <div className="teamPriceRow">
                      <div className="team">{e.split(":")[0]}</div>
                      <div className="teamPriceCell">
                        <b>{e.split(":")[1]}</b>/personne
                      </div>
                    </div>
                  ))}
                {data.formulaireParticipation && (
                  <div className="enrollByGroup">
                    <a
                      href={
                        data.formulaireParticipation &&
                        data.formulaireParticipation
                      }
                    >
                      Participer
                    </a>
                  </div>
                )}
              </div>

              <div className="teamOnsite">
                <div className="priceByTeamTitle">Étudier en ligne</div>
                {data.prixParGroupeOnline &&
                  data.prixParGroupeOnline.split("/").map((e) => (
                    <div className="teamPriceRow">
                      <div className="team">{e.split(":")[0]}</div>
                      <div className="teamPriceCell">
                        <b>{e.split(":")[1]}</b>/personne
                      </div>
                    </div>
                  ))}
                {data.formulaireParticipation && (
                  <div className="enrollByGroup">
                    <a
                      href={
                        data.formulaireParticipation &&
                        data.formulaireParticipation
                      }
                    >
                      Participer
                    </a>
                  </div>
                )}
              </div>
            </div> : <div>
            {data.formulaireParticipation && (
                  <div className="enrollByGroup">
                    <a
                      href={
                        data.formulaireParticipation &&
                        data.formulaireParticipation
                      }
                    >
                      Participer
                    </a>
                  </div>
                )}
            </div>
            }
            
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default DetailedFormation;
